import type { ChatMessage } from "../types/redux";
import { migrateMessageContent } from "./chatMigrations";

export interface RehydratedHistory {
  messages: ChatMessage[];
  todoPlans: Record<string, { plan: unknown; scopeSummary: unknown }>;
}

/** A regular turn renders as the user's question followed by the bot's answer. */
function pushConversationTurn(target: ChatMessage[], turn: any): void {
  if (turn.userInputText) {
    target.push({
      sender: "user",
      text: turn.userInputText,
      timestamp: turn.createdAt,
      turnId: turn.turnId,
    });
  }

  if (!turn.finalChatResponse) return;

  target.push({
    sender: "chatbot",
    // Phase 8: migrate the old fact format (^fid=xxx^) to [[FACT:xxx]] so
    // messages stored before the refactor still render clickable citations
    text: migrateMessageContent(turn.finalChatResponse),
    timestamp: turn.createdAt,
    turnId: turn.turnId,
    inlineOrder: [], // not persisted — facts are parsed back out of the text
  });
}

/** Turn the backend's turn list into the messages and todo plans the UI holds. */
export function buildRehydratedHistory(turns: any[]): RehydratedHistory {
  const messages: ChatMessage[] = [];
  const todoPlans: RehydratedHistory["todoPlans"] = {};

  for (const turn of turns) {
    pushConversationTurn(messages, turn);

    if (turn.todoPlan && turn.turnId) {
      todoPlans[turn.turnId] = {
        plan: turn.todoPlan,
        scopeSummary: turn.scopePlan, // Backend uses scopePlan, not scopeSummary
      };
    }
  }

  return { messages, todoPlans };
}
